(function () {
  const root = document.querySelector('[data-gws-checker]');
  if (!root) return;

  const cfg = window.CloudinoGwsCheckerConfig || {};
  const params = new URLSearchParams(window.location.search);

  // HỆ THỐNG CHỈ ĐỌC CHU KỲ VÀ LUỒNG - XÓA BỎ HOÀN TOÀN BIẾN URL TRIAL_VARIANT ĐỂ CHỐNG HACK
  const billingCycle = params.get('billing') || 'annual';
  const isTrialFlow = params.get('flow') === 'trial';
  let variantId = params.get('variant') || '';
  const planHandle = params.get('plan') || '';

  const domainInput = document.getElementById('GwsDomain');
  const seatsInput = document.getElementById('GwsSeats');
  const checkButton = document.getElementById('GwsCheckDomain');
  const checkoutButton = document.getElementById('GwsCheckout');
  const message = document.getElementById('GwsMessage');
  const selectedPlan = document.getElementById('GwsSelectedPlan');

  // Khối định vị các phần tử giao diện cần chuyển đổi nội dung
  const eyebrowEl = document.getElementById('GwsEyebrow');
  const headingEl = document.getElementById('GwsMainHeading');
  const subtitleEl = document.getElementById('GwsSubtitle');
  const refundNoticeEl = document.getElementById('GwsRefundNotice');
  const summaryLabelEl = document.getElementById('GwsSummaryLabel');

  const state = {
    verified: false,
    eligible: false,
    domain: '',
    seats: 1
  };

  const priceState = {
    loaded: false,
    annualPrice: 0,
    monthlyPrice: 0
  };

  // BIẾN KIỂM TRA ĐỂ KHÓA CHẶT HỆ THỐNG NẾU PHÁT HIỆN HACK HOẶC SÓT CẤU HÌNH
  let isSecurityConfigValid = true;

  // LUỒNG TRIAL: THỰC THI BIẾN ĐỔI GIAO DIỆN VÀ ĐÁNH TRÁO ID TỪ SERVER LIQUID
  if (isTrialFlow) {
    if (eyebrowEl) {
      eyebrowEl.textContent = "Google Workspace Free Trial";
    }
    if (headingEl) {
      headingEl.textContent = "Verify domain for your free trial";
    }
    if (subtitleEl) {
      subtitleEl.textContent = "Your 30-day free trial will be provisioned directly to your custom corporate domain. Let's verify its eligibility status first.";
    }
    if (summaryLabelEl) {
      summaryLabelEl.textContent = "Selected trial plan";
    }
    if (checkoutButton) {
      checkoutButton.textContent = "Start Free Trial";
    }
    
    if (refundNoticeEl) {
      refundNoticeEl.style.background = "#e8f5e9";
      refundNoticeEl.style.borderColor = "#c8e6c9";
      refundNoticeEl.style.color = "#1b5e20";
      refundNoticeEl.innerHTML = "<strong>Trial Agreement Notice:</strong> You are initializing a 30-day complimentary ecosystem evaluation. No active billing methods are required for provisioning today. *Note: Maximum 20 licenses allowed per trial instance.";
    }

    // BẢO MẬT TUYỆT ĐỐI: Chỉ bốc mã ID từ Server Liquid do Hệ thống quản trị sinh ra, hacker chịu chết không sửa được
    if (cfg.trialVariants && cfg.trialVariants[planHandle] && cfg.trialVariants[planHandle] !== "") {
      variantId = cfg.trialVariants[planHandle];
    } else {
      // KHÓA CHẶT HỆ THỐNG: Nếu phát hiện cấu hình trống, kích hoạt chế độ phong tỏa bảo mật
      isSecurityConfigValid = false;
      console.error("[Cloudino Security Breach/Error] Luồng Trial được gọi nhưng không tìm thấy cấu hình mã ID 0đ hợp pháp trên Server cho gói: " + planHandle);
    }
  }

  // HÀM ĐỊNH DẠNG TÊN HIỂN THỊ CỦA GÓI SẢN PHẨM
  function formatPlan(handle) {
    if (!handle) {
      return 'Google Workspace';
    }
    
    var baseName = handle
      .replace(/^google-workspace-/, '')
      .replace(/-/g, ' ')
      .replace(/\b\w/g, function (c) { 
        return c.toUpperCase(); 
      });
    
    if (isTrialFlow) {
      return baseName + ' Trial Plan (30-Day Free Trial)';
    }
    
    if (billingCycle === 'monthly') {
      return baseName + ' (Monthly Plan)';
    } else {
      return baseName + ' (Annual Plan)';
    }
  }

  if (selectedPlan) {
    selectedPlan.textContent = formatPlan(planHandle);
  }

  function normalizeDomain(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/^https?:\/\//, '')
      .replace(/^www\./, '')
      .replace(/\/.*$/, '');
  }

  function validDomain(domain) {
    return /^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?(\.[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)+$/i.test(domain);
  }

  function showMessage(type, title, body, actions) {
    message.className = 'gws-message is-' + type;
    message.innerHTML = `
      <strong>${title}</strong>
      <div>${body}</div>
      ${actions ? `<ul>${actions.map(item => `<li>${item}</li>`).join('')}</ul>` : ''}
    `;
  }

  function resetVerification() {
    state.verified = false;
    state.eligible = false;
    state.domain = '';
    state.seats = 1;

    if (checkoutButton) {
      checkoutButton.disabled = true;
    }
  }

  async function loadVariantPrice() {
    if (isTrialFlow) {
      priceState.annualPrice = 0;
      priceState.monthlyPrice = 0;
      priceState.loaded = true;
      return;
    }

    if (!planHandle || !variantId) {
      return;
    }

    try {
      const res = await fetch('/products/' + planHandle + '.js', {
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!res.ok) {
        console.warn('Unable to load product JSON for price.');
        return;
      }

      const product = await res.json();
      const variants = product.variants || [];

      const variant = variants.find(function (v) {
        return String(v.id) === String(variantId);
      });

      if (!variant || !variant.price) {
        console.warn('Variant price not found.');
        return;
      }

      var loadedPrice = Number(variant.price) / 100;
      var vTitle = String(variant.title || '').toLowerCase();

      if (vTitle.includes('month') || vTitle.includes('tháng') || billingCycle === 'monthly') {
        priceState.monthlyPrice = loadedPrice;
        priceState.annualPrice = loadedPrice * 12;
      } else {
        priceState.annualPrice = loadedPrice;
        priceState.monthlyPrice = loadedPrice / 12;
      }
      
      priceState.loaded = true;
    } catch (err) {
      console.error('Unable to load variant price:', err);
    }
  }

  function getUnitMonthlyPriceText() {
    if (isTrialFlow) {
      return 'USD 0.00 (Free Trial)';
    }
    if (!priceState.monthlyPrice || priceState.monthlyPrice <= 0) {
      return 'Not available';
    }
    return 'USD ' + priceState.monthlyPrice.toFixed(2) + ' / user / month';
  }

  function getPriceFormulaText() {
    if (isTrialFlow) {
      return '30-Day Complimentary Infrastructure Evaluation Access';
    }
    if (!priceState.monthlyPrice || priceState.monthlyPrice <= 0) {
      return 'Not available';
    }
    if (billingCycle === 'monthly') {
      return state.seats + ' licenses x USD ' + priceState.monthlyPrice.toFixed(2) + ' / month (Monthly Commitment)';
    }
    return state.seats + ' licenses x USD ' + priceState.monthlyPrice.toFixed(2) + ' / month x 12 months';
  }

  function getAnnualTotalText() {
    if (isTrialFlow) {
      return 'USD 0.00 (No cost today)';
    }
    if (!priceState.monthlyPrice || priceState.monthlyPrice <= 0) {
      return 'Not available';
    }
    if (billingCycle === 'monthly') {
      return 'USD ' + (state.seats * priceState.monthlyPrice).toFixed(2) + ' / month';
    }
    return 'USD ' + (state.seats * priceState.annualPrice).toFixed(2);
  }

  function getErrorMessage(result) {
    const reason = result && result.reason ? result.reason : 'UNKNOWN';

    const messages = {
      INVALID_DOMAIN: {
        title: 'Invalid domain format.',
        body: 'Please enter a valid business domain.',
        actions: [
          'Use a format like example.com, company.sg, or cloudino.io.',
          'Do not enter https://example.com, www.example.com, or user@example.com.'
        ]
      },
      DOMAIN_NOT_FOUND: {
        title: 'We could not find this domain.',
        body: 'The domain does not appear to be registered or reachable.',
        actions: [
          'Please check the spelling of your domain.',
          'Make sure the domain has already been registered.',
          'Try again after confirming your domain name.'
        ]
      },
      DOMAIN_ALREADY_HAS_GOOGLE_WORKSPACE: {
        title: 'This domain already has Google Workspace.',
        body: 'This domain appears to be associated with an existing Google Workspace subscription.',
        actions: [
          'Use another domain and try again.',
          'If you want to transfer your subscription to Cloudino, please contact support.',
          'If your organization already owns this subscription, do not create a duplicate purchase.'
        ]
      },
      DOMAIN_LINKED_TO_ANOTHER_RESELLER: {
        title: 'This domain is managed by another Google Workspace reseller.',
        body: 'The domain may already be linked to an existing Google Workspace customer account.',
        actions: [
          'Use another domain if you want to purchase a new subscription.',
          'Contact Cloudino Support if you want to transfer your subscription.',
          'Our team will guide you through the transfer process.'
        ]
      },
      DOMAIN_NOT_ELIGIBLE: {
        title: 'This domain is not eligible for a new Google Workspace purchase.',
        body: ' We cannot continue checkout for this domain at the moment.',
        actions: [
          'Try another domain.',
          'Contact Cloudino Support if you believe this is a mistake.'
        ]
      },
      API_TIMEOUT: {
        title: 'We could not verify your domain right now.',
        body: 'The verification service is temporarily unavailable or timed out.',
        actions: [
          'Please try again in a few minutes.',
          'If the issue persists, contact Cloudino Support.'
        ]
      },
      FORBIDDEN: {
        title: 'Domain verification is not authorized.',
        body: 'The verification request could not be authorized.',
        actions: [
          'Please refresh the page and try again.',
          'If the issue continues, contact Cloudino Support.'
        ]
      },
      UNKNOWN: {
        title: 'Domain verification failed.',
        body: 'We could not complete the domain check.',
        actions: [
          'Please try again.',
          'Contact Cloudino Support if the issue continues.'
        ]
      }
    };

    return messages[reason] || messages.UNKNOWN;
  }

  async function verifyDomainOnly() {
    resetVerification();

    const domain = normalizeDomain(domainInput.value);
    let seats = Math.max(1, parseInt(seatsInput.value || '1', 10));

    // CHẶN HẠN MỨC 20 USER CHO LUỒNG TRIAL
    if (isTrialFlow && seats > 20) {
      seats = 20;
      seatsInput.value = 20;
      alert("Free Trial setup is limited to a maximum of 20 licenses. For plans requiring larger user deployments, please proceed with our standard subscription or contact team sales.");
    }

    // BẮT CHẶN BẢO MẬT: Nếu cấu hình Server bị lỗi/thiếu ID Trial, chặn đứng quy trình check domain
    if (isTrialFlow && !isSecurityConfigValid) {
      showMessage(
        'error',
        'Security Deployment Error.',
        'This trial funnel lacks valid server-side variant mapping allocation data. Pipeline aborted for merchant safety.',
        ['Please ensure Trial Variant IDs are fully provisioned within the theme customize manager.']
      );
      return;
    }

    if (!variantId) {
      showMessage(
        'error',
        'Product information is missing.',
        'We could not identify the Google Workspace plan selection or Trial Variant mapping configuration.',
        [
          'Please return to the homepage and verify your path.',
          'Ensure the Trial Variant IDs are correctly provisioned in Customize settings.'
        ]
      );
      return;
    }

    if (!validDomain(domain)) {
      const msg = getErrorMessage({ reason: 'INVALID_DOMAIN' });
      showMessage('error', msg.title, msg.body, msg.actions);
      return;
    }

    checkButton.disabled = true;
    checkButton.textContent = 'Verifying domain...';

    showMessage(
      'info',
      'Checking your domain eligibility...',
      'Please wait while we verify whether this domain can be used for a new Google Workspace subscription.'
    );

    try {
      let result = null;

      if (cfg.fallbackSuccess) {
        result = {
          eligible: true,
          message: 'Test mode: domain accepted.'
        };
      } else {
        if (!cfg.apiEndpoint) {
          throw { reason: 'API_TIMEOUT' };
        }

        const res = await fetch(cfg.apiEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Cloudino-Api-Key': cfg.apiKey || ''
          },
          body: JSON.stringify({
            domain: domain,
            plan: planHandle,
            variantId: params.get('variant') || variantId, // Luôn gửi ID gốc để API của ông nhận diện đúng cấu trúc gói gốc
            seats: seats
          })
        });

        result = await res.json().catch(function () { return {}; });

        if (!res.ok) {
          throw result;
        }
      }

      if (!result || !result.eligible) {
        const msg = getErrorMessage(result);
        showMessage('error', msg.title, msg.body, msg.actions);

        checkButton.disabled = false;
        checkButton.textContent = 'Verify Domain';

        return;
      }

      state.verified = true;
      state.eligible = true;
      state.domain = domain;
      state.seats = seats;

      if (checkoutButton) {
        checkoutButton.disabled = false;
      }

      if (isTrialFlow) {
        showMessage(
          'success',
          'Domain verification successful!',
          'Your corporate infrastructure is eligible to activate a 30-day trial period under this plan architecture.',
          [
            'Click Start Free Trial to finalize allocation protocols.',
            'No automated transactions or fee collections will be executed at checkout.'
          ]
        );
      } else {
        showMessage(
          'success',
          'Great! Your domain is eligible.',
          'Your domain can be used for a new Google Workspace subscription. You may continue to checkout when ready.',
          [
            'You can still change the domain and verify again before continuing.',
            'Click Continue to Checkout when you are ready to purchase.'
          ]
        );
      }

      checkButton.disabled = false;
      checkButton.textContent = 'Verify Another Domain';
    } catch (err) {
      console.error(err);

      const msg = getErrorMessage(err && err.reason ? err : { reason: 'API_TIMEOUT' });
      showMessage('error', msg.title, msg.body, msg.actions);

      checkButton.disabled = false;
      checkButton.textContent = 'Verify Domain';
    }
  }

  async function continueToCheckout() {
    if (!state.verified || !state.eligible || !state.domain) {
      showMessage(
        'error',
        'Please verify your domain first.',
        'You need to verify an eligible business domain before continuing to checkout.',
        [
          'Enter your domain.',
          'Click Verify Domain.',
          'Continue only after the domain is eligible.'
        ]
      );
      return;
    }

    // KHÓA CHẶT TUYỆT ĐỐI LUỒNG TRIAL TRƯỚC KHI ĐẨY SANG THANH TOÁN
    if (isTrialFlow && !isSecurityConfigValid) {
      showMessage('error', 'Security Breach Blocked.', 'Server mapping invalid. Processing terminated.', []);
      return;
    }

    const currentDomain = normalizeDomain(domainInput.value);
    let currentSeats = Math.max(1, parseInt(seatsInput.value || '1', 10));

    if (isTrialFlow && currentSeats > 20) {
      currentSeats = 20;
      seatsInput.value = 20;
    }

    state.seats = currentSeats;

    checkoutButton.disabled = true;
    checkoutButton.textContent = isTrialFlow ? 'Preparing trial...' : 'Preparing checkout...';

    try {
      if (cfg.clearCartBeforeCheckout) {
        await fetch('/cart/clear.js', { method: 'POST' });
      }

      const totalLabelKey = billingCycle === 'monthly' ? 'Monthly Subscription Total' : 'Subscription Total';

      const payload = {
        items: [
          {
            id: Number(variantId), // MÃ ID GỐC 0Đ ĐƯỢC CHỐT CHẶT TỪ SERVER LIQUID, KHÔNG THỂ BỊ HACK QUA URL
            quantity: Number(state.seats),
            properties: {
              'Google Workspace Domain': state.domain,
              'Selected Plan': formatPlan(planHandle),
              '✅ Number of Licenses': String(state.seats),
              'Price per License': getUnitMonthlyPriceText(),
              'Billing Period': isTrialFlow ? '30-Day Free Evaluation Period' : (billingCycle === 'monthly' ? 'Monthly Commitment' : 'Annual Commitment (12 Months)'),
              'Price Formula': getPriceFormulaText(),
              [totalLabelKey]: getAnnualTotalText(),
              '⚠️ Order Notice': isTrialFlow 
                ? 'This infrastructure allocation is free for 30 days. Subscriptions will scale to baseline billing parameters post-evaluation.'
                : 'After payment is completed, Google Workspace subscription fees are non-refundable.'
            }
          }
        ]
      };

      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!addRes.ok) {
        throw new Error('Unable to add item to cart.');
      }

      window.location.href = '/checkout';
    } catch (err) {
      console.error(err);

      showMessage(
        'error',
        'We could not prepare your checkout.',
        'Your domain was verified, but we could not add the selected Google Workspace plan to cart.',
        [
          'Please try again.',
          'If the issue continues, contact Cloudino Support.'
        ]
      );

      checkoutButton.disabled = false;
      checkoutButton.textContent = isTrialFlow ? 'Start Free Trial' : 'Continue to Checkout';
    }
  }

  domainInput.addEventListener('input', function () {
    resetVerification();
    checkButton.textContent = 'Verify Domain';
  });

  seatsInput.addEventListener('change', function () {
    var val = parseInt(seatsInput.value || '1', 10);
    
    if (isTrialFlow && val > 20) {
      seatsInput.value = 20;
      val = 20;
      alert("Free Trial setup is limited to a maximum of 20 licenses. For plans requiring larger user deployments, please proceed with our standard subscription or contact team sales.");
    }
    
    if (state.verified && state.eligible) {
      state.seats = Math.max(1, val);
    }
  });

  loadVariantPrice();

  checkButton.addEventListener('click', verifyDomainOnly);

  if (checkoutButton) {
    checkoutButton.addEventListener('click', continueToCheckout);
  }
})();